export default "__VITE_ASSET__Bolnsxx4__"